import { render, staticRenderFns } from "./LocalCasamentoCollapse.vue?vue&type=template&id=5afcefb1&scoped=true&"
import script from "./LocalCasamentoCollapse.vue?vue&type=script&lang=js&"
export * from "./LocalCasamentoCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afcefb1",
  null
  
)

export default component.exports